import { SettingsRow, SettingsSection, SettingsToggle } from './SettingsControls'
import { useSettingsForm } from './useSettingsForm'

export function SettingsValidationTab() {
  const { draft, set } = useSettingsForm()

  return (
    <>
      <SettingsSection
        title="Duplicate Detection"
        help="Control how the system handles duplicate records."
      >
        <SettingsToggle
          setting="skipDuplicateDocNumbers"
          label="Skip rows with duplicate document numbers"
          help="Skip transactions whose invoice or bill number already exists in QuickBooks."
        />
        <SettingsToggle
          setting="skipInFileDuplicates"
          label="Skip duplicate rows within the file"
          help="Skip rows that appear more than once in the same upload."
        />
      </SettingsSection>

      <SettingsSection
        title="Data Validation Rules"
        help="Set boundaries for what data is considered valid."
      >
        <SettingsToggle
          setting="allowNegativeQuantities"
          label="Allow negative quantities"
          help="Permit negative values in quantity fields, for example returns or adjustments."
        />
        <SettingsToggle
          setting="allowClosedPeriodDates"
          label="Allow transactions in closed periods"
          help="Permit transaction dates that fall in an accounting period already closed in QuickBooks."
        />

        {/* JournalEntry only: CheckBalanced is the sole consumer, and it compares
            the entry's total debits with its total credits. It is not a general
            line-total-versus-header check. */}
        <SettingsRow
          htmlFor="tolerance"
          label="Journal Entry Balance Tolerance"
          help="The largest gap allowed between a journal entry's total debits and total credits before the entry is rejected. Lets rounding differences through while still catching real mistakes. Applies to journal entries only."
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>$</span>
            <input
              className="bb-input"
              id="tolerance"
              type="number"
              step="0.01"
              min={0}
              style={{ maxWidth: 120 }}
              value={draft.amountTolerance}
              onChange={(event) => set('amountTolerance', Number(event.target.value))}
            />
          </div>
        </SettingsRow>
      </SettingsSection>
    </>
  )
}
